export default __webpack_public_path__ + "static/media/score-ratcatcher-ii.ba3d12eb.png";